import { useQueryClient } from 'react-query';
import {
  organizationSiteApiKeys,
  useOrganizationSiteApi,
} from '@hooks/api/useOrganizationSiteApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type { ApiOptions } from 'types/api';
import type { OrganizationSiteProfileResponse } from 'types/organization-site';

export const useUnpublishSiteProfile = (
  organizationId: string,
  options: ApiOptions<OrganizationSiteProfileResponse> = {}
) => {
  const api = useOrganizationSiteApi();
  const queryClient = useQueryClient();

  const { isPosting, post, ...response } = usePostApi({
    ...options,
    getSuccessMessage: () => 'Site has been unpublished',
    onSuccess: (data, ...args) => {
      queryClient.invalidateQueries(
        organizationSiteApiKeys.get(organizationId)
      );
      options?.onSuccess?.(data, ...args);
    },
    request: () => api.unpublish(organizationId),
  });

  return {
    ...response,
    isUnpublishingSiteProfile: isPosting,
    unpublishSiteProfile: post,
  };
};
